// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__jtLUk","mainContent":"Layout_mainContent__I9vIr"};